import common from "./module/common";
import undefined from "./module/undefined";
import login from "./module/login";
import register from "./module/register";
import forget from "./module/forget";
import reset from "./module/reset";
import account from "./module/account";
import index from "./module/index";
import enroll from "./module/enroll/index";
import verify from "./module/verify";
import invoice from "./module/invoice";
import feeLetter from "./module/feeLetter";
import home from "./module/home";
import creation from "./module/creation";
import notPaid from "./module/notPaid";
import payment from "./module/payment";

export default {
  common: common.zh,
  undefined: undefined.zh,
  login: login.zh,
  register: register.zh,
  forget: forget.zh,
  reset: reset.zh,
  account: account.zh,
  index: index.zh,
  enroll: enroll.zh,
  verify: verify.zh,
  invoice: invoice.zh,
  feeLetter: feeLetter.zh,
  home: home.zh,
  creation: creation.zh,
  notPaid: notPaid.zh,
  payment: payment.zh,
};
